import React, {useEffect} from "react";
import {useStyles} from "./styles/EvenWritingQuizStyle";
import {
    Box,
    Button,
    Typography,
    TextField,
    Select, MenuItem, FormControl
} from "@material-ui/core";
import clsx from "clsx";
import { ReactComponent as ArrowDownIcon } from '../../../../../common/images/ArrowDownIcon.svg';
import EduLangTabs from "../../../../../components/EduLangTabs";
import {withRouter} from "react-router-dom";
import {inject, observer} from "mobx-react";

function EvenStepThree(props) {
    const classes = useStyles();

    const { contentStore, evenStepThreeStore } = props;
    const { contentTapIndex, selectedContent, matchQuizzes, notMatchCount } = evenStepThreeStore;

    useEffect(() => {
        evenStepThreeStore.getEvenStepThreeContent(contentStore.stepValue, contentStore.dayValue);
        contentStore.setOnSave(onSave);
        return ()=> {
            contentStore.setOnSave(null);
            evenStepThreeStore.initEvenStepThreeContent(contentStore.stepValue, contentStore.dayValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const onSave = () => {
        evenStepThreeStore.modifyEvenStepThreeContent(contentStore.stepValue, contentStore.dayValue);
    }

    const handleTabChange = (event, newValue) => {
        evenStepThreeStore.setContentTapIndex(newValue);
    }

    const handleClickNotMatchCount = (e) => {
        evenStepThreeStore.setNotMatchCount(e.target.value);
    }

    const handleKeywordChange = (e, index) => {
        evenStepThreeStore.setKeyword(e.target.value, index);
    }

    const handleWordChange = (e, index, direction) => {
        evenStepThreeStore.setWord(e.target.value, index, direction);
    }

    const handleClickGenerateWords = (generateCount) => {
        contentStore.getGeneratedWords(evenStepThreeStore.getSelectedLangCode(), generateCount, (words) => evenStepThreeStore.setGenerateWords(words));
    }

    const handleClickGenerateQuizzes = (generateCount) => {
        contentStore.getGeneratedWords(evenStepThreeStore.getSelectedLangCode(), generateCount, (words) => evenStepThreeStore.setGenerateQuizzes(words));
    }

    return (
        <div className={classes.root}>
            <Box className={clsx(classes.boxWrap, classes.heightStep1)}>
                <Box>
                    <Box position="static" className={classes.tabBox}>
                        <EduLangTabs value={contentTapIndex} handleChange={handleTabChange}/>
                    </Box>
                    <Box className={classes.textBox}>
                        <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'}>
                            <Typography className={classes.notMatchText}>Not match</Typography>
                            <FormControl className={classes.formControl}>
                                <Select
                                    IconComponent={(props) => (
                                        <Box>
                                            <ArrowDownIcon  {...props} />
                                        </Box>
                                    )}
                                    value={notMatchCount}
                                    onChange={handleClickNotMatchCount}
                                    MenuProps={{
                                        anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "right"
                                        },
                                        transformOrigin:{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        },
                                        className:classes.selectPopover
                                    }}
                                >
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                    <MenuItem value={3}>3</MenuItem>
                                    <MenuItem value={4}>4</MenuItem>
                                    <MenuItem value={5}>5</MenuItem>
                                </Select>
                            </FormControl>
                            <Box className={clsx(classes.disableButtonStyle, classes.activeButtonStyle)}>
                                <Button disableRipple onClick={() => handleClickGenerateWords(evenStepThreeStore.notMatchCount)}>
                                    <Typography>단어 생성</Typography>
                                </Button>
                            </Box>
                        </Box>
                        <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'} className={clsx(classes.textFieldStyle, classes.marginStyle)}>
                            <Typography className={classes.notMatchText}>제시 단어</Typography>
                            {!!matchQuizzes.length ? matchQuizzes.map((content, i) => (
                                <TextField id="outlined-basic"
                                           variant="outlined"
                                           onChange={(e) => handleKeywordChange(e, i)}
                                           placeholder="단어 입력"
                                           value={content}
                                           key={i}/>
                            )) :
                                <>
                                    <TextField id="outlined-basic" variant="outlined" placeholder="단어 입력" />
                                    <TextField id="outlined-basic" variant="outlined" placeholder="단어 입력" />
                                    <TextField id="outlined-basic" variant="outlined" placeholder="단어 입력" />
                                </>
                            }
                            <Box className={clsx(classes.disableButtonStyle, classes.activeButtonStyle)} sx={{marginLeft: 10}}>
                                <Button disableRipple onClick={() => handleClickGenerateQuizzes(9)}>
                                    <Typography>퀴즈 생성</Typography>
                                </Button>
                            </Box>
                        </Box>
                        <Box className={classes.matchWordList}>
                            {selectedContent.map((content, i) => (
                                <Box
                                    display={'flex'}
                                    justifyContent={'flex-start'}
                                    className={classes.matchWord}
                                    alignItems={'center'}
                                    key={i}
                                >
                                    <TextField
                                        id="outlined-basic"
                                        className={clsx(classes.quizText, content.leftWord === content.rightWord ? classes.correctQuizText : classes.incorrectQuizText)}
                                        value={content.leftWord}
                                        variant="outlined"
                                        placeholder="단어 수정"
                                        onChange={(e) => handleWordChange(e, i, 'leftWord')}
                                    />
                                    <TextField
                                        id="outlined-basic"
                                        className={clsx(classes.quizText, content.leftWord === content.rightWord ? classes.correctQuizText : classes.incorrectQuizText)}
                                        value={content.rightWord}
                                        variant="outlined"
                                        placeholder="단어 수정"
                                        onChange={(e) => handleWordChange(e, i, 'rightWord')}
                                    />
                                </Box>
                            ))}
                        </Box>
                    </Box>
                </Box>
            </Box>
        </div>
    );
}

export default withRouter(inject('contentStore','evenStepThreeStore')(observer(EvenStepThree)));
